import { render, staticRenderFns } from "./systemParticularsCashier.vue?vue&type=template&id=55255fec&scoped=true&"
import script from "./systemParticularsCashier.vue?vue&type=script&lang=js&"
export * from "./systemParticularsCashier.vue?vue&type=script&lang=js&"
import style0 from "./systemParticularsCashier.vue?vue&type=style&index=0&id=55255fec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55255fec",
  null
  
)

export default component.exports